import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const linkCls = ({ isActive }) =>
    `font-mono-plex uppercase text-[11px] tracking-[0.25em] transition-colors ${
      isActive ? "text-[#FF5E00]" : "text-white/70 hover:text-white"
    }`;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/5">
      <div className="container-x flex items-center justify-between py-4">
        <Link to="/" className="led-hover flex items-center gap-2" data-testid="nav-logo">
          <div className="w-8 h-8 bg-[#FF5E00] flex items-center justify-center">
            <span className="font-display font-black text-black text-sm">2B</span>
          </div>
          <span className="font-display font-black uppercase tracking-tight text-lg">2B FUNK</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/catalog" className={linkCls} data-testid="nav-catalog">Catalog</NavLink>
          <NavLink to="/pricing" className={linkCls} data-testid="nav-pricing">Plans</NavLink>
          <NavLink to="/ai" className={linkCls} data-testid="nav-ai">2BF AI</NavLink>
          {user && <NavLink to="/community" className={linkCls} data-testid="nav-community">Community</NavLink>}
          {user && <NavLink to="/profile" className={linkCls} data-testid="nav-profile">Profile</NavLink>}
          {user?.role === "admin" && <NavLink to="/admin" className={linkCls} data-testid="nav-admin">Admin</NavLink>}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <div className="flex items-center gap-2 px-3 py-1.5 border border-white/10 bg-white/[0.02]" data-testid="nav-credits">
                <span className="text-[10px] font-mono-plex uppercase tracking-widest text-white/50">Credits</span>
                <span className="font-display font-bold text-[#B3FF00]">{user.credits ?? 0}</span>
              </div>
              <button onClick={handleLogout} className="btn-outline flex items-center gap-2" data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-outline" data-testid="nav-login-btn">Sign In</Link>
              <Link to="/register" className="btn-primary" data-testid="nav-register-btn">Sign Up</Link>
            </>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-black/90">
          <div className="container-x py-4 flex flex-col gap-3">
            <NavLink onClick={() => setOpen(false)} to="/catalog" className={linkCls}>Catalog</NavLink>
            <NavLink onClick={() => setOpen(false)} to="/pricing" className={linkCls}>Plans</NavLink>
            <NavLink onClick={() => setOpen(false)} to="/ai" className={linkCls}>2BF AI</NavLink>
            {user && <NavLink onClick={() => setOpen(false)} to="/community" className={linkCls}>Community</NavLink>}
            {user && <NavLink onClick={() => setOpen(false)} to="/profile" className={linkCls}>Profile</NavLink>}
            {user?.role === "admin" && <NavLink onClick={() => setOpen(false)} to="/admin" className={linkCls}>Admin</NavLink>}
            <div className="pt-3 border-t border-white/5">
              {user ? (
                <button onClick={handleLogout} className="btn-outline w-full">Logout</button>
              ) : (
                <div className="flex gap-2">
                  <Link to="/login" className="btn-outline flex-1 text-center" onClick={() => setOpen(false)}>Sign In</Link>
                  <Link to="/register" className="btn-primary flex-1 text-center" onClick={() => setOpen(false)}>Sign Up</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
